export default () => ({
    usersConfig: {
        include: 'company,roles',
        sort: 'id',
        sortDirection: '',
        page: 1,
        filters: {},
        per_page: 15
    },
    users: null,
    usersFilters: null,
    newUser: {
        name: null,
        job_title: null,
        email: null,
        phone: null,
        user_type : 0,
        locale: null,
        role: null
    },
    newWebhook: {
        name: null,
        url: null,
        signature_secret: null
    },
    company: null,
    companySettings: null,
    companyHeaderMail: null
})
